/**
 * @author: Corey Sanford <corey@hackcapital.com>
 * @date:   2019-01-04 10:14:38
 *
 * Search for exact values, as in the case of hotnesses
 */

import { QueryBuilderBase } from './QueryBuilderBase';

const DEFAULT_EMPTY_VALUE = '';

export class ExactMatchQueryBuilder extends QueryBuilderBase {

  /**
   * @param {mixed} The value of the field when empty
   */
  setEmptyValue(valueWhenEmpty) {
    this.valueWhenEmpty = valueWhenEmpty;
  }

  emptyValue() {
    return this.valueWhenEmpty || DEFAULT_EMPTY_VALUE;
  }

  static get Operators() {
    return {
      CONTAINS_ANY: { name: 'is one of', needValue: true },
      CONTAINS_NONE: { name: 'is not one of', needValue: true },
      HAS_NONE: { name: 'is empty', needValue: false },
      HAS_ANY: { name: 'is not empty', needValue: false },
    };
  }

  buildCondition(fieldName, operands, operator) {
    operands = (operands && operands.length) ? [...operands] : [];
    let condition = {};

    switch (operator) {
      case this.constructor.Operators.CONTAINS_ANY.name:
        condition = ExactMatchQueryBuilder.containsManyQuery(fieldName, operands, '$or', operand => {
          return { [fieldName]: operand };
        });
        break;
      case this.constructor.Operators.CONTAINS_NONE.name:
        condition = ExactMatchQueryBuilder.containsManyQuery(fieldName, operands, '$and', operand => {
          return { [fieldName]: { $ne: operand } };
        });
        break;
      case this.constructor.Operators.HAS_NONE.name:
        condition = { [fieldName]: this.emptyValue() };
        break;
      case this.constructor.Operators.HAS_ANY.name:
        condition = { [fieldName]: { $ne: this.emptyValue() } };
        break;
      default:
        throw new Error(`Unsupported operator: ${operator}`);
    }

    // Check if the condition is empty
    if ((Array.isArray(condition) && condition.length === 0) ||
      (Object.keys(condition).length === 0)) {
      return null;
    }

    return condition;
  }

  /**
   * Construct a contains any query
   *
   * @param {string} fieldName
   * @param {Array} operands - values to match against
   * @param {string} andOr - either '$and' or '$or'
   * @param {function} queryConstructor - to assemble the query with fieldname and operand
   */
  static containsManyQuery(fieldName, operands, andOr, queryConstructor) {
    operands = this.convertToArray(operands);

    if (operands.length === 0) {
      return {};
    }

    const query = {
      [andOr]: [],
    };

    operands.forEach(operand => {

      query[andOr].push(queryConstructor(operand));
    });
    return query;
  }

  /**
   * If not already an array, convert to array.
   *
   * @param {mixed} items
   */
  static convertToArray(items) {
    if (!Array.isArray(items)) {
      items = [items];
    }

    return items;
  }
}
